import React from 'react'
import { Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const DarkCard = (props) =>{
    return (
        <Card bg = "dark" className = "my-2" text = "white">
            <span className="position-absolute top-0 start-50 translate-middle p-2 bg-white border border-light rounded-circle">
                <span className="visually-hidden">New alerts</span>
            </span>
            <Card.Header>{props.title}</Card.Header>
            <Card.Body>
            <Card.Title ></Card.Title>
            <Card.Text>
                {props.p}
            </Card.Text>
            <Link className = "w-100 btn btn-outline-light" to={props.Link}>Ver</Link>
            </Card.Body>
        </Card>
    )
}
export default DarkCard